/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { isDocumentInLiquidMode, isFileQualified } from "selectors/liquidModeViewSelectors";

export const getLiquidModeApis = stores => {
  function enterLiquidModeView() {
    stores.liquidModeViewStore.enterLiquidMode();
  }

  function exitLiquidModeView() {
    stores.liquidModeViewStore.exitLiquidMode();
  }

  function isDocumentInLiquidModeView() {
    return isDocumentInLiquidMode(stores);
  }

  function isLiquidModeViewEnabled() {
    return isFileQualified(stores);
  }

  return {
    enterLiquidModeView,
    exitLiquidModeView,
    isDocumentInLiquidModeView,
    isLiquidModeViewEnabled
  };
};

export const registerLiquidModeApis = stores => {
  apiFactory.registerApi(publicApiNames.LIQUIDMODE, clientName => getLiquidModeApis(stores), true);
};
